import React, { useEffect, useState } from "react";
import clone from "lodash.clonedeep";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { Button, ButtonGroup } from "react-bootstrap";
import {
    getEventTags,
    getEpisodeTags,
    createEventTag,
    updateEventTag,
    addEpisodeTag,
    removeEpisodeTag,
    updateEpisodeTagsOrder
} from "../../../../../api/cp";
import {Event} from "../../../Comet";
import DraggableBlock from "../components/DraggableBlock";
import TagsUpdateModal from "../EditModals/TagsUpdateModal";

const TagsTab = ({eventKey, episode}) => {
    const [eventTagsList, setEventTagsList] = useState([]);
    const [episodeTagsList, setEpisodeTagsList] = useState([]);
    const [editableTag, setEditableTag] = useState(null);
    const [isTagsListModalVisible, setTagsListModalVisible] = useState(false);

    useEffect(() => {
        fetchEventTagsList();
    }, []);

    useEffect(() => {
        setEpisodeTagsList(episode.tags || []);
    }, [episode]);

    async function fetchEventTagsList() {
        try {
            const data = await getEventTags(eventKey);
            setEventTagsList(data);
        } catch (error) {
            console.error(error);
        }
    }

    async function fetchEpisodeTagsList() {
        try {
            const data = await getEpisodeTags(episode.id);
            setEpisodeTagsList(data);
        } catch (error) {
            console.error(error);
        }
    }

    function onDragEnd(result) {
        if (!result.destination) {
            return;
        }

        const reorderedPartners = reorder(
            episodeTagsList,
            result.source.index,
            result.destination.index,
        );

        handleUpdateTagsList(reorderedPartners);
    }

    function reorder(list, startIndex, endIndex) {
        const result = clone(list);
        const [removed] = result.splice(startIndex, 1);
        result.splice(endIndex, 0, removed);

        return result;
    }

    async function handleAddEventTag(tag) {
        try {
            const response = await createEventTag(eventKey, tag);
            setEventTagsList((prevState) => [...prevState, response]);
        } catch (error) {
            console.error(error);
        }
    }

    async function handleUpdateEventTag(editedTag) {
        try {
            await updateEventTag(editedTag.id, editedTag);
            fetchEpisodeTagsList();
        } catch (error) {
            console.error(error);
        }
    }

    function handleEditTag(tag) {
        setEditableTag(tag);
        setTagsListModalVisible(true);
    }

    async function handleSaveEpisodeTag(tag) {
        try {
            await addEpisodeTag(episode.id, tag.id, tag);
            setEpisodeTagsList((prevState) => [...prevState, tag]);
        } catch (error) {
            console.error(error);
        }
    }

    async function handleDeleteEpisodeTag(id) {
        try {
            await removeEpisodeTag(episode.id, id);
            fetchEpisodeTagsList();
        } catch (error) {
            console.error(error);
        }
    }

    const handleCloseModal = () => {
        setTagsListModalVisible(false);
    };

    async function handleUpdateTagsList(list) {
        try {
            setEpisodeTagsList(list);
            const payload = list.map(({id}) => id);
            await updateEpisodeTagsOrder(episode.id, payload);
        } catch (error) {
            console.error(error);
        }
    }

    const handleCometEpisodeUpdate = (episode) => {
        setEpisodeTagsList(episode.tags);
    };

    return (
        <div style={{marginTop: '12px'}}>
            <Event event="update:episode" handler={handleCometEpisodeUpdate} />
            <DragDropContext onDragEnd={onDragEnd}>
                <Droppable droppableId="droppable">
                    {(provided) => (
                        <div
                            {...provided.droppableProps}
                            ref={provided.innerRef}
                        >
                            {episodeTagsList?.map((tag, index) => (
                                <Draggable
                                    key={tag.id}
                                    draggableId={`${tag.id || index}`}
                                    index={index}
                                >
                                    {(provided) => (
                                        <div
                                            ref={provided.innerRef}
                                            {...provided.draggableProps}
                                            {...provided.dragHandleProps}
                                            style={
                                                provided.draggableProps.style
                                            }
                                        >
                                            <DraggableBlock
                                                block={tag}
                                                color={tag.color}
                                                onEdit={handleEditTag}
                                                onDelete={handleDeleteEpisodeTag}
                                            />
                                        </div>
                                    )}
                                </Draggable>
                            ))}
                            {provided.placeholder}
                        </div>
                    )}
                </Droppable>
            </DragDropContext>
            <ButtonGroup style={{marginTop: !!episodeTagsList.length ? '20px' : 0}}>
                <Button
                    disabled={episodeTagsList.length === 7}
                    onClick={() => {
                        setEditableTag(null);
                        setTagsListModalVisible(true);
                    }}
                >
                    Добавить тег
                </Button>
            </ButtonGroup>

            <TagsUpdateModal
                editableTag={editableTag}
                tagsList={eventTagsList}
                show={isTagsListModalVisible}
                onSave={handleSaveEpisodeTag}
                onUpdate={handleUpdateEventTag}
                onClose={handleCloseModal}
                onAddToList={handleAddEventTag}
            />
        </div>
    );
};

export default TagsTab;
